/*
 * Copyright (c) 2018 teamapps.org (see code comments for author's name)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {DeferredExecutor} from "./DeferredExecutor";

export function executeWhenAttached(onlyOnce?: boolean) {
	return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {

		modifyOnAttachedToDomIfNotYetDone(target);

		let oldMethod = descriptor.value;
		descriptor.value = function () {
			if (!this.__deferredExecutor) {
				this.__deferredExecutor = new DeferredExecutor();
				this.__deferredExecutor.ready = this.attachedToDom;
			}
			if (onlyOnce) {
				this.__deferredExecutor.invokeOnceWhenReady(oldMethod, this, arguments);
			} else {
				this.__deferredExecutor.invokeWhenReady(oldMethod, this, arguments);
			}
		};
	};
}

function modifyOnAttachedToDomIfNotYetDone(proto: any) {
	if (!proto.__executeWhenAttachedSupport) {
		let oldMethod = proto.onAttachedToDom;
		proto.onAttachedToDom = function () {
			if (!this.__deferredExecutor) {
				this.__deferredExecutor = new DeferredExecutor();
			}
			oldMethod.apply(this, arguments);
			this.__deferredExecutor.ready = true;
		};
		proto.__executeWhenAttachedSupport = true;
	}
}


